/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaOutside: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="outside" viewBox="0 0 15 15">
      <g>
        <g clipPath="url(#a)">
          <path d="M7.5 11.25a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Zm0-1.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM6.875.625a.625.625 0 0 1 1.25 0v1.25a.625.625 0 0 1-1.25 0V.625Zm0 12.5a.625.625 0 0 1 1.25 0v1.25a.625.625 0 0 1-1.25 0v-1.25ZM2.195 3.079a.624.624 0 1 1 .884-.883l.888.887a.624.624 0 1 1-.884.884l-.887-.888Zm8.838 8.838a.624.624 0 1 1 .884-.884l.887.888a.624.624 0 1 1-.883.883l-.888-.887ZM.625 8.125a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25H.625Zm12.5 0a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25h-1.25Zm-10.046 4.68a.624.624 0 1 1-.883-.884l.887-.888a.624.624 0 1 1 .884.884l-.888.887Zm8.838-8.838a.624.624 0 1 1-.884-.884l.888-.887a.624.624 0 1 1 .883.883l-.887.888Z"></path>
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h15v15H0z"></path>
        </clipPath>
      </defs>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaOutside)
